/**
 * Opens a page that belongs to a project. Inside the active project it is a
 * plain navigation; for another project the workspace is switched first.
 *
 * switchWorkspace reloads the page on whatever URL is showing, so the address
 * bar is pointed at the target first (replaceState does not re-render: the
 * router does not listen to it) and put back if the switch fails, in which
 * case the error is thrown for the caller to report.
 */
export async function openInProject(opts: {
  target: string;
  projectId: string | null;
  activeProjectId: string | null;
  navigate: (to: string) => void;
  switchWorkspace: (projectId: string) => Promise<void>;
}): Promise<void> {
  const { target, projectId, activeProjectId, navigate, switchWorkspace } = opts;
  if (!projectId || projectId === activeProjectId) {
    navigate(target);
    return;
  }
  const here = `${window.location.pathname}${window.location.search}`;
  window.history.replaceState(window.history.state, '', target);
  try {
    await switchWorkspace(projectId);
  } catch (err) {
    window.history.replaceState(window.history.state, '', here);
    throw err;
  }
}
